"use client";

import React from "react";
import { Clock, Shield, Zap } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefits = [{
  title: "Cosmic Alignment",
  description: "Understand how the current planetary transits influence your intimate energy and emotional connections this month.",
  icon: Zap
}, {
  title: "Elemental Wisdom",
  description: "Explore the unique dynamics between Fire, Earth, Air, and Water signs to find your most harmonious romantic matches.",
  icon: Shield
}, {
  title: "Daily Guidance",
  description: "Receive curated celestial advice designed to help you navigate the complexities of modern love and wellness.",
  icon: Clock
}];
export default function WhyChooseUs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224816" id="celestial-insights" className="bg-background text-foreground py-20 px-4 md:px-8 lg:px-16 overflow-hidden">
      <div ref={ref} className={`max-w-screen-xl mx-auto transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-default font-bold text-foreground tracking-tight mb-4">
            Celestial Insights
          </h2>
          <p className="text-muted-foreground font-sans max-w-2xl mx-auto text-lg leading-relaxed">
            Unlock the secrets of the stars to enhance your personal wellness and deepen your most intimate relationships.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {benefits.map((benefit, i) => {
          const Icon = benefit.icon;
          return <Card key={i} data-index={i} className="group border border-border bg-gradient-to-b from-secondary to-background transition-all duration-500 hover:-translate-y-1 hover:border-primary/40 hover:shadow-xl hover:shadow-primary/5 rounded-xl">
                <CardHeader className="pb-4">
                  <div className="w-14 h-14 rounded-full bg-primary/5 flex items-center justify-center mb-4 group-hover:bg-primary/10 transition-colors duration-400">
                    <Icon className="w-6 h-6 text-primary" />
                  </div>
                  <CardTitle className="font-default text-xl text-foreground group-hover:text-primary transition-colors duration-400">
                    {benefit.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="font-sans text-muted-foreground leading-relaxed">
                    {benefit.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}